import URI from 'urijs';
import util from './util';

const DEFAULTS = {};

function TabPanel(container, opts) {
    this.container = container;
    this.tabs = container.querySelectorAll('[role="tab"]');
    this.selectedIndex = 0;
    this.options = util.extend({}, DEFAULTS, opts);

    initialise(container);
}

function initialise(container) {
    initialiseState(container);
    initialiseInteraction(container);
    setInitiallySelectedTab(container);
}

function initialiseState(container) {
    const firstTab = container.querySelector('[role="tab"]');
    if (!firstTab) return;

    firstTab.setAttribute('aria-selected', true);

    Array.from(container.querySelectorAll('[role="tabpanel"]')).forEach((panel) => {
        util.showElement(panel, false);
    });
}

function initialiseInteraction(container) {
    const tabs = container.querySelectorAll('[role="tab"]');
    Array.prototype.forEach.call(tabs, (tab) => {
        tab.addEventListener('click', tabSelected);
    });
}

function setInitiallySelectedTab(container) {
    const event = {
        target: container.querySelector('[data-initial="true"]'),
    };
    setSelectedTab(event);
}

function tabSelected(event) {
    event.preventDefault();
    if (event.target.getAttribute('aria-selected')) {
        return;
    }
    setSelectedTab(event);
}

function setSelectedTab(event) {
    const tabs = document.querySelectorAll('[role="tab"]');
    const tabSelectedEvent = new CustomEvent(
        'tabpanel.tabSelected',
        { bubbles: true, cancelable: true },
    );
    Array.prototype.forEach.call(tabs, (tab) => {
        if (tab === event.target) {
            tab.setAttribute('aria-selected', true);
            showPanel(tab.getAttribute('aria-controls'));
            tab.focus();
            window.currentTabUrl = tab.getAttribute('href');

            const tabLink = tab.getAttribute('href') || '';

            if (tabLink && window.history.replaceState) {
                const match = tabLink.match(/^\?([^=]*)=(.*)$/);
                if (match) {
                    const [, key, tabId] = match;
                    const url = URI(window.location).setQuery(key, tabId).toString();
                    window.history.replaceState(null, null, url);
                }
            }

            // ensure tab is visible
            const tabRect = tab.getBoundingClientRect();
            const parentRect = tab.parentElement.getBoundingClientRect();

            if (tabRect.left < parentRect.left) {
                tab.parentElement.scrollLeft -= parentRect.left - tabRect.left;
            } else if (tabRect.right > parentRect.right) {
                tab.parentElement.scrollLeft += tabRect.right - parentRect.right;
            }

            tab.dispatchEvent(tabSelectedEvent);
        } else {
            tab.removeAttribute('aria-selected');
        }
    });
}

function showPanel(id) {
    const panel = document.getElementById(id);
    const panels = panel.parentNode.querySelectorAll('[role="tabpanel"]');
    Array.prototype.forEach.call(panels, (tabPanel) => {
        util.showElement(tabPanel, false);
    });
    util.showElement(panel);
}

window.TabPanel = TabPanel;
// Aria selector initialiser for tab interactivity
function ariaInit() {
    const tabPanels = document.querySelectorAll('[role="tablist"]');
    Array.prototype.forEach.call(tabPanels, (tabPanel) => {
        const container = tabPanel.parentNode;

        // eslint-disable-next-line no-new
        new TabPanel(container);
    });
}
document.addEventListener('DOMContentLoaded', ariaInit);
